var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KycAddressForm',{attrs:{"googleAutocompleteService":_vm.googleAutocompleteService,"googleGeocoder":_vm.googleGeocoder,"storedForm":_vm.getUserInformationAddress,"patchProfile":_vm.patchProfile},on:{"submit":_vm.next}})}
var staticRenderFns = []

export { render, staticRenderFns }